import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dsa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

function triggerBlobDownload(data, fileName) {
  const url = window.URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function downloadPdf(cvId, lang, fileName) {
  const token = localStorage.getItem("dsa_token");
  const res = await axios.get(`${API}/cvs/${cvId}/pdf?lang=${lang}`, {
    responseType: "blob",
    headers: { Authorization: `Bearer ${token}` },
  });
  triggerBlobDownload(res.data, fileName || `cv_${lang}.pdf`);
}

export async function downloadSharedPdf(shareToken, lang, fileName) {
  const res = await axios.get(`${API}/shared/${shareToken}/pdf?lang=${lang}`, { responseType: "blob" });
  triggerBlobDownload(res.data, fileName || `cv_${lang}.pdf`);
}

export async function downloadReferenceBriefPdf(cvId, lang, fileName) {
  const token = localStorage.getItem("dsa_token");
  const res = await axios.get(`${API}/cvs/${cvId}/reference-brief/pdf?lang=${lang}`, {
    responseType: "blob",
    headers: { Authorization: `Bearer ${token}` },
  });
  triggerBlobDownload(res.data, fileName || `reference_brief_${lang}.pdf`);
}

export async function downloadSharedReferenceBriefPdf(shareToken, lang, fileName) {
  const res = await axios.get(`${API}/shared/${shareToken}/reference-brief/pdf?lang=${lang}`, { responseType: "blob" });
  triggerBlobDownload(res.data, fileName || `reference_brief_${lang}.pdf`);
}

export async function uploadPhoto(cvId, file) {
  const token = localStorage.getItem("dsa_token");
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(`${API}/cvs/${cvId}/photo`, form, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
  return data; // {photoUrl, photoPath}
}

export { API };
